// src/pages/controleBar/comandas/JuntarComandasModal.js
import React, { useState } from "react";
import './JuntarComandasModal.css';
import ModalPortal from '../../../components/modalForm/ModalPortal';

const JuntarComandasModal = ({ open, onClose, comandas, onConfirm }) => {
  const [selecionadas, setSelecionadas] = useState([]);

  if (!open) return null;

  const toggleSelecionada = (id) => {
    setSelecionadas((prev) =>
      prev.includes(id) ? prev.filter((cid) => cid !== id) : [...prev, id]
    );
  };

  const handleConfirm = () => {
    if (selecionadas.length < 2) {
      alert("Selecione pelo menos duas comandas para juntar.");
      return;
    }
    onConfirm(selecionadas);
  };

  return (
    <ModalPortal show={open}>
    <div className="modal-comanda-overlay">
      <div className="modal-comanda-content">
        <h3>Juntar Comandas</h3>
        <p>Selecione as comandas que deseja unir em uma só:</p>

        <div style={{ maxHeight: "60vh", overflowY: "auto", marginTop: "10px" }}>
          {comandas.map((c) => (
            <label
              key={c.id}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                marginBottom: "6px",
              }}
            >
              <input
                type="checkbox"
                checked={selecionadas.includes(c.id)}
                onChange={() => toggleSelecionada(c.id)}
              />
              <span>
                #{c.codigo} -{" "}
                {c.nomeCliente === "CONSUMIDOR FINAL" ? "Sem nome" : c.nomeCliente}
              </span>
            </label>
          ))}
        </div>

        <div
          className="modal-comanda-actions"
          style={{
            marginTop: "15px",
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
          }}
        >
          <button className="red" onClick={onClose}>Cancelar</button>
          <button className="green" onClick={handleConfirm}>Confirmar</button>
        </div>
      </div>
    </div>
    </ModalPortal>
  );
};

export default JuntarComandasModal;
